// import { useContext } from "react";
// import AuthProvider from "../context/AuthContext";

// const Loader = () => {
//   let { loader } = useContext(AuthProvider);
//   return (
//     <div id="loading" className="loading" style={{ display: loader ? "flex" : "none" }}>
//       <div className="loading-box">
//         <div className="loading-spinner"></div>
//       </div>
//     </div>
//   );
// };

// export default Loader;


import { useContext } from "react";
import AuthProvider from "../context/AuthContext";

const Loader = () => {
  let { loader } = useContext(AuthProvider);

  const containerStyle = {
    display: loader ? 'flex' : 'none', // Conditional display based on loader state
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    position: 'fixed', // Ensure it covers the entire screen
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9999 // Ensure it appears above other content
  };

  const boxStyle = {
    position: 'relative',
    width: '128px',
    height: '128px',
    border: '1px solid #000',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background:'white'
  };

  const dotStyle = {
    position: 'absolute',
    width: '32px',
    height: '32px',
    backgroundColor: '#2C485A',
    borderRadius: '50%',
    animation: 'bounceHorizontal 0.6s ease-in-out infinite'
  };

  const dotDelayedStyle = {
    position: 'absolute',
    width: '32px',
    height: '32px',
    backgroundColor: '#fbbf24',
    borderRadius: '50%',
    animation: 'bounceHorizontal 0.6s ease-in-out infinite',
    opacity: 0.75,
    animationDelay: '0.15s'
  };

  const textStyle = {
    paddingTop: '64px',

  }

  return (
    <div id="loading" style={containerStyle}>
      <div style={boxStyle}>
        <div style={dotStyle}></div>
        <div style={dotDelayedStyle}></div>
        <span style={textStyle}>Loading...</span>
      </div>

      <style>{`
        @keyframes bounceHorizontal {
          0%, 100% {
            transform: translateX(-20px);
          }
          50% {
            transform: translateX(20px);
          }
        }
      `}</style>
    </div>
  );
};

export default Loader;